<div class="row">
  <div class="col-12">
    <div class="asap-grid-layout-header">
      <div class="row">
        <div class="col-12 col-xl-5 leftAllign">
          @if (!showTextBox) {
            <div (dblclick)="showTextbox()" class="gridTitle">{{title}}</div>
          }
          <div>
            @if (showTextBox) {
              <input type="text" #titleTextBox [value]="title" id="titleTextBox"
                (blur)="closeTextbox($event.target)" (keyup.enter)="closeTextbox($event.target)" />
            }
          </div>
          @if (listItems.length > 0 && !this._currentUser.isEnterprise) {
            <div class="mt-3 BatchSpanAndPoSpan" style="float: left;"
              >
              <span class="batchActionSpan">
                <img class="batchimage" [src]="'/assets/menu/'+ _theme +'/batch-icon_grid.svg'" />
              </span>
              <kendo-combobox #kendo_batchactions [data]="listItems" [allowCustom]="allowCustom" class="batchActions"
                [placeholder]="'Batch Actions'" (valueChange)="_batchAction($event)">
                <span>
                  <img class="imageAdd" [src]="'/assets/menu/'+ _theme +'/group-icon_grid.svg'" />
                </span>
              </kendo-combobox>
            </div>
          }

          @if (page == 'asset-purchaseOrders') {
            <div class="mt-3 BatchSpanAndPoSpan">
              @if (!_inActiveMode) {
                <span class="assetPurchaseOrderSpan">Show</span>
              }
              @if (!_inActiveMode) {
                <kendo-combobox class="assetPurchaseOrderCombobox batchActions"
                  #kendo_assetpurchaseOrdersStatus
                  [data]="assetPurchaseOrdersStatusFiltered" [filterable]="true"
                  (valueChange)="_handlePoStatusChange($event)" (filterChange)="_handlePoStatusFilter($event)"
                  [suggest]="true" [value]="assetPurchaseOrdersStatusValue" [textField]="'code'" [valueField]="'id'"
                  [placeholder]="'Purchase Order Status'">
                  <span>
                    <img class="imageAdd" [src]="'/assets/menu/'+ _theme +'/group-icon_grid.svg'" />
                  </span>
                </kendo-combobox>
              }
            </div>
          }

          @if (page == 'purchaseOrders') {
            <div class="mt-3 BatchSpanAndPoSpan">
              @if (!_inActiveMode) {
                <span class="assetPurchaseOrderSpan">Show</span>
              }
              @if (!_inActiveMode) {
                <kendo-combobox class="assetPurchaseOrderCombobox batchActions"
                  #kendo_stockpurchaseOrdersStatus
                  [data]="stockPurchaseOrdersStatusFiltered" [filterable]="true"
                  (valueChange)="_handleStockPoStatusChange($event)" (filterChange)="_handleStockPoStatusFilter($event)"
                  [suggest]="true" [value]="stockPurchaseOrdersStatusValue" [textField]="'code'" [valueField]="'id'"
                  [placeholder]="'Purchase Order Status'">
                  <span>
                    <img class="imageAdd" [src]="'/assets/menu/'+ _theme +'/group-icon_grid.svg'" />
                  </span>
                </kendo-combobox>
              }
            </div>
          }

          @if (page == 'salesOrders') {
            <div class="mt-3 BatchSpanAndPoSpan">
              @if (!_inActiveMode) {
                <span class="assetPurchaseOrderSpan">Show</span>
              }
              @if (!_inActiveMode) {
                <kendo-combobox class="assetPurchaseOrderCombobox batchActions"
                  #kendo_stockSalesOrdersStatus
                  [data]="stockSalesOrdersStatusFiltered" [filterable]="true"
                  (valueChange)="_handleStockSoStatusChange($event)" (filterChange)="_handleStockSoStatusFilter($event)"
                  [suggest]="true" [value]="stockSalesOrdersStatusValue" [textField]="'code'" [valueField]="'id'"
                  [placeholder]="'Sales Order Status'">
                  <span>
                    <img class="imageAdd" [src]="'/assets/menu/'+ _theme +'/group-icon_grid.svg'" />
                  </span>
                </kendo-combobox>
              }
            </div>
          }

          @if (page == 'siteTransfers' || page == 'site-transfers') {
            <div class="mt-3 BatchSpanAndPoSpan">
              @if (!_inActiveMode) {
                <span class="assetPurchaseOrderSpan">Show</span>
              }
              @if (!_inActiveMode) {
                <kendo-combobox class="assetPurchaseOrderCombobox batchActions"
                  #kendo_siteTransfersStatus
                  [data]="siteTransfersStatusFiltered" [filterable]="true"
                  (valueChange)="_handleSiteTransferStatusChange($event)" (filterChange)="_handleSiteTransferStatusFilter($event)"
                  [suggest]="true" [value]="siteTransfersStatusValue" [textField]="'code'" [valueField]="'id'"
                  [placeholder]="'Site Transfer Status'">
                  <span>
                    <img class="imageAdd" [src]="'/assets/menu/'+ _theme +'/group-icon_grid.svg'" />
                  </span>
                </kendo-combobox>
              }
            </div>
          }

          @if (isAssetReservation) {
            <div class="mt-3 BatchSpanAndPoSpan">
              <span class="assetPurchaseOrderSpan">Show</span>
              <kendo-combobox class="assetPurchaseOrderCombobox batchActions" #kendo_assetReservation
                [data]="assetReservationFiltered" [filterable]="true" (valueChange)="_handleReservationChange($event)"
                (filterChange)="_handleReservationFilter($event)" [suggest]="true" [value]="assetReservationValue"
                [textField]="'code'" [valueField]="'id'" [placeholder]="'Select ...'">
                <span>
                  <img class="imageAdd" [src]="'/assets/menu/'+ _theme +'/group-icon_grid.svg'" />
                </span>
              </kendo-combobox>
            </div>
          }

          @if (overridePage == 'stockdispose-authorization-history' || page == 'stockdispose-authorization-history' || overridePage == 'stockadjust-authorization-history' || page == 'stockadjust-authorization-history') {
            <div class="mt-3 BatchSpanAndPoSpan"
              >
              <span class="assetPurchaseOrderSpan">Show</span>
              <kendo-combobox class="assetPurchaseOrderCombobox batchActions" #kendo_DisposeAuthorization
                [data]="disposeAuthorizationStatusFiltered" [filterable]="true"
                (valueChange)="_handleDisposeAuthorizationChange($event)"
                (filterChange)="_handleDisposeAuthorizationFilter($event)" [suggest]="true"
                [value]="disposeAuthorizationStatusValue" [textField]="'code'" [valueField]="'id'"
                [placeholder]="'Select ...'">
                <span>
                  <img class="imageAdd" [src]="'/assets/menu/'+ _theme +'/group-icon_grid.svg'" />
                </span>
              </kendo-combobox>
            </div>
          }

          @if (page == 'perform-maintenance' || overridePage == 'perform-maintenance' || isPerformMaintenance) {
            <div class="mt-3 BatchSpanAndPoSpan"
              >
              <span class="assetPurchaseOrderSpan">Show</span>
              <kendo-combobox class="assetPurchaseOrderCombobox batchActions" #kendo_performMaintenance
                [data]="performMaintenanceFiltered" [filterable]="true"
                (valueChange)="_handlePerformMaintenanceChange($event)"
                (filterChange)="_handlePerformMaintenanceFilter($event)" [suggest]="true"
                [value]="performMaintenanceValue" [textField]="'code'" [valueField]="'id'"
                [placeholder]="'Select ...'">
                <span>
                  <img class="imageAdd" [src]="'/assets/menu/'+ _theme +'/group-icon_grid.svg'" />
                </span>
              </kendo-combobox>
            </div>
          }

          @if (page == 'history' || page == 'asset-all-history' || isHistoryPage) {
            <div class="mt-3 BatchSpanAndPoSpan">
              <span class="assetPurchaseOrderSpan" style="margin-left: 0; margin-right: 8px; font-weight: bold; font-size: 13px; color: #484848;">Filter By</span>
              <kendo-combobox class="assetPurchaseOrderCombobox batchActions" #kendo_historyFilter
                [data]="historyFilterOptions" [filterable]="false"
                (valueChange)="_handleHistoryFilterChange($event)"
                [suggest]="true" [value]="historyFilterValue" [textField]="'text'" [valueField]="'value'"
                [placeholder]="'Filter By Date'">
              </kendo-combobox>
            </div>
          }

        </div>
        <div class="col-12 col-xl-7 rightAllign">
          <div>
            <ul class="buttonsList">
              @if (graphEnabled) {
                <li class="linksButtons expCollapseButtonLi">
                  <div (click)="_onToggleGraph()" class="expCollapseButton">
                    @if (_showGraph) {
                      <img [src]="'/assets/menu/'+ _theme +'/collapse-graph-icon.svg'" />Collapse
                      to hide the Graphs<i class="fa fa-angle-up" aria-hidden="true"></i>
                    }
                    @if (!_showGraph) {
                      <img [src]="'/assets/menu/'+ _theme +'/collapse-graph-icon.svg'" />Expand to show the Graphs<i
                    class="fa fa-angle-down" aria-hidden="true"></i>
                  }
                </div>
              </li>
            }
            @if (groupingEnabled) {
              <li class="linksButtons" (click)="_toggleGrouping()">
                <span>
                  <img class="imageAdd" [src]="'/assets/menu/'+ _theme +'/group-icon_grid.svg'" />
                </span>
                @if (_groupingEnabled) {
                  Disable Group view
                }
                @if (!_groupingEnabled) {
                  Group view
                }
              </li>
            }
            @if (addNewFormEnabled) {
              <li class="linksButtons" (click)="_addNew()">
                <span>
                  <img class="imageAdd" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                </span>Add new
              </li>
            }
            @if (editColumnsEnabled) {
              <li class="linksButtons"
                (click)="_getGridFieldColumnsUpdated(); _editColumnsActive = true;SendEditColumnsValueToGridLayoutService();">
                <span>
                  <img class="imageAdd" [src]="'/assets/menu/enterprise/select-column-icon.jpg'" />
                </span>Edit Columns
              </li>
            }
            @if (reloadDataEnabled) {
              <li class="linksButtons"
                (click)="_inActiveMode ? _onRefresh(true,true) : _onRefresh(false,false)">
                <span>
                  <img class="imagerefresh" [src]="'/assets/menu/'+ _theme +'/refresh-icon_grid.svg'" />
                </span>
              </li>
            }
            @if (searchEnable) {
              <li class="searchLi">
                <div class="search-container">
                  <input placeholder="Search..." [class.ossystem]="_isOs" (keyup.enter)="doSearch($event.target)"
                    kendoTextBox #search [formControl]="_searchControl" class="searchInput ossystem"
                    spellcheck="false" />
                    <span class="search-icons">
                      @if (_searchControl.value) {
                        <i class="fa fa-times clear-icon" (click)="clearSearch()"
                        title="Clear search"></i>
                      }
                      <img [src]="'/assets/menu/' + _theme + '/search-icon_grid.svg'" class="search-icon"
                        (click)="doSearch($event.target)" title="Search" alt="Search" />
                      </span>
                    </div>
                  </li>
                }
              </ul>
            </div>
            <div class="mt-3">
              <ul class="menueList">
                @if (exportExcelEnable) {
                  <li (click)="_onExportExcelExportPdf()">
                    Export to Excel
                  </li>
                }
                @if (exportPDFEnable) {
                  <li (click)="_onExportExcelExportPdf(true)">
                    Export to PDF
                  </li>
                }
                @if (exportCSVEnabled) {
                  <li (click)="_onExportCSV()">
                    Export to CSV
                  </li>
                }
                @if (exportWordEnabled) {
                  <li (click)="_onExportWord()">
                    Export to Word
                  </li>
                }
                @if (importEnable && (_generalLicense?.excelImport || _generalLicense?.textImport)) {
                  <li (click)="_onImport()">Import</li>
                }
                <!-- <li>Export</li> -->
                @if (deletedEnabled) {
                  @if (_inActiveMode) {
                    <li (click)="_onRefresh(false,false)">
                      View Active
                    </li>
                  }
                  @if (!_inActiveMode) {
                    <li (click)="_onRefresh(true,true)">
                      View Inactive
                    </li>
                  }
                }
                <ng-container>
                  @if (!_isClosed && page=='pickList') {
                    <li (click)="_onOpenCloseChange(true)">
                      View Closed
                    </li>
                  }

                  @if (_isClosed && page=='pickList') {
                    <li (click)="_onOpenCloseChange()">
                      View Open
                    </li>
                  }
                </ng-container>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (_isDialiog) {
    <asap-dialog-layout [data]="_dialogModel" [componentName]="_dialogComponentName"
      (closeDialog)="_closeDialog($event)">
    </asap-dialog-layout>
  }

  @if (_editColumnsActive) {
    <kendo-window (close)="_editColumnsActive = false;SendEditColumnsValueToGridLayoutService();"
      title="Edit Columns" class="edit-columns-window">
      <app-edit-columns [data]="_groupedData" [selectedColumns]="_selectedColumns"
        (save)="_gridFieldsSelected($event);SendEditColumnsValueToGridLayoutService();"
      (close)="_editColumnsActive = false;SendEditColumnsValueToGridLayoutService();"></app-edit-columns>
    </kendo-window>
  }
  @if (_editColumnsActive) {
    <div class="k-overlay"></div>
  }